// extracted by mini-css-extract-plugin
export default {"placeholder":"validatedCandidatesPlaceholder_placeholder__hlAZv","placeholderText":"validatedCandidatesPlaceholder_placeholderText__NJ-8Y"};